"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MarqueeAttributionBlock;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
const AttributionText = /*#__PURE__*/(0, _react2.styled)("figcaption")({
  name: "AttributionText",
  class: "pl-a1j9a1x7",
  vars: {
    "a1j9a1x7-1": [({
      tabletAttributionPosition
    }) => tabletAttributionPosition === 'bottom-left' || tabletAttributionPosition === 'bottom-right' ? 'flex-end' : 'initial'],
    "a1j9a1x7-2": [({
      tabletAttributionPosition
    }) => tabletAttributionPosition === 'bottom-left' || tabletAttributionPosition === 'top-left' ? 'start' : 'end'],
    "a1j9a1x7-3": [({
      tabletAttributionPosition
    }) => tabletAttributionPosition === 'bottom-right' || tabletAttributionPosition === 'top-right' ? '1' : 'initial'],
    "a1j9a1x7-5": [({
      attributionPosition
    }) => attributionPosition === 'bottom-left' || attributionPosition === 'bottom-right' ? 'flex-end' : 'initial'],
    "a1j9a1x7-6": [({
      attributionPosition
    }) => attributionPosition === 'bottom-left' || attributionPosition === 'top-left' ? 'start' : 'end'],
    "a1j9a1x7-7": [({
      attributionPosition
    }) => attributionPosition === 'bottom-right' || attributionPosition === 'top-right' ? '1' : 'unset'],
    "a1j9a1x7-8": [({
      attributionPosition
    }) => attributionPosition === 'bottom-left' || attributionPosition === 'bottom-right' ? 'var(--fixed-space-300)' : '0'],
    "a1j9a1x7-9": [({
      attributionPosition
    }) => attributionPosition === 'top-left' || attributionPosition === 'top-right' ? 'var(--fixed-space-300)' : '0']
  }
});
const AttributionUrl = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "AttributionUrl",
  class: "pl-anb6tvb"
});

/**
 * TODO: refactor to normalize with feature blade version.
 *
 * Render attribution block.
 *
 * @param {string} props.attribution attribution text
 * @param {string} props.attributionUrl attribution text
 * @param {string} props.attributionPosition attribution text position
 * @param {string} props.tabletAttributionPosition tablet attribution text position
 * @returns {React.ReactElement} Attribution Block Component
 * @public
 */
function MarqueeAttributionBlock({
  attribution,
  attributionUrl,
  attributionPosition,
  tabletAttributionPosition
}) {
  if (!attribution) return null;
  return /*#__PURE__*/_react.default.createElement(AttributionText, {
    attributionPosition: attributionPosition,
    tabletAttributionPosition: tabletAttributionPosition,
    "data-cy": "attribution-block"
  }, (0, _patternLibraryUtils.formatAttribution)(attribution), attributionUrl && /*#__PURE__*/_react.default.createElement(AttributionUrl, null, attributionUrl));
}
MarqueeAttributionBlock.propTypes = {
  attribution: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  attributionUrl: _propTypes.default.string,
  attributionPosition: _propTypes.default.oneOf(['bottom-left', 'bottom-right', 'top-left', 'top-right']),
  tabletAttributionPosition: _propTypes.default.oneOf(['bottom-left', 'bottom-right', 'top-left', 'top-right'])
};